import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ActivationMailSentModalComponent } from './activation-mail-sent-modal';

export const ActivationMailSentModalModule: string = ng
    .module('activation-mail-sent-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('activationMailSentModal', ActivationMailSentModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/activation-mail-sent-modal/activation-mail-sent-modal.module.ts